var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendationsBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.035,
    height: 18.842,
    viewBox: "0 0 16.035 18.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M3561.271,8854.558l-4.807-4.381a1.428,1.428,0,0,1-.031-2.113,1.67,1.67,0,0,1,2.255-.028l4.807,4.381a1.427,1.427,0,0,1,.031,2.112,1.667,1.667,0,0,1-2.255.029Zm-12.328-1.066v-9.774a6.569,6.569,0,0,1,8.02-6.4,6.671,6.671,0,0,1,5.1,6.569,1.49,1.49,0,0,1-2.979,0,3.68,3.68,0,0,0-2.759-3.66,3.62,3.62,0,0,0-3.063.7,3.565,3.565,0,0,0-1.341,2.79v9.774a1.49,1.49,0,1,1-2.979,0Z",
    transform: "translate(-3548.443 -8836.641)",
    fill: "#333",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationsBlackIcon);
export default __webpack_public_path__ + "static/media/recommendationsBlackIcon.09583022f74c8e3441a92d42ba12645d.svg";
export { ForwardRef as ReactComponent };